import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Typography,
  FormControl,
  TextField,
  CardContent,
  Grid,
  Button,
  CircularProgress,
} from "@mui/material";
import { appSelector } from "../../redux/selector";
import { useSelector } from "react-redux";
import axios from "axios";
import Key from "../../../clientVariables.json";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { myCandidatesSelector } from "../redux/selector";

const SocialNetwork = ({ formDataHnadler }) => {
  const { candidateDetails } = useSelector(myCandidatesSelector);

  const [formData, setFormData] = useState({
    linkedIn: "",
    // skype: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    setFormData({
      linkedIn: candidateDetails?.linkedin_url || "",
    });
    // formDataHnadler(formData, 'f6');
  }, [candidateDetails]);

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    await formDataHnadler(formData, "f6");

    try {
      const response = await axios.post(
        `${Key.domain}/candidate/update/other/${candidateDetails?.candidate_id}`,
        {
          linkedin_url: formData.linkedIn,
          skype: formData?.skype || "",
        }
      );
      handleOpenSnackbar("candidate details updated successfully", "success");
    } catch (error) {
      console.error(error);
      handleOpenSnackbar("Something went wrong", "error");
    }
    setIsSubmitting(false);
  };

  return (
    <Card sx={cardStyles}>
      <CardHeader
        title={
          <Typography variant="h6" sx={headerStyles}>
            Social Networks
          </Typography>
        }
      />
      <CardContent
        sx={{
          ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
            padding: "8px 6px",
          },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Linkedin
                </Typography>
                <TextField
                  id="linkedIn"
                  label=""
                  variant="outlined"
                  placeholder="https://www.linkedin.com/in/james/"
                  value={formData.linkedIn}
                  onChange={handleInputChange("linkedIn")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            {/* <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={{ color: "rgb(160, 171, 184)" }}>
                  Twitter
                </Typography>
                <TextField
                  id="twitter"
                  label=""
                  variant="outlined"
                  placeholder="https://twitter.com/"
                  value={formData.twitter}
                  onChange={handleInputChange("twitter")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid> */}
            {/* <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={{ color: "rgb(160, 171, 184)" }}>
                  Skype
                </Typography>
                <TextField
                  id="skype"
                  label=""
                  variant="outlined"
                  placeholder="https://skype.com"
                  value={formData.skype}
                  onChange={handleInputChange("skype")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid> */}

            <Grid item xs={12} textAlign="end">
              <Button
                type="submit"
                variant="contained"
                sx={{ bgcolor: "#406882" }}
              >
                {isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Card>
  );
};

export default SocialNetwork;

const cardStyles = {
  boxShadow: "none",
  borderRadius: "8px",
};

const headerStyles = {
  color: "rgb(102, 120, 156)",
  fontSize: "16px",
  fontWeight: 600,
};

const labelStyles = {
  color: "rgb(160, 171, 184)",
};

const inputStyles = {
  border: "1px solid 	rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid 	rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
